function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import { WDHComponent } from '../../../../wdh-foundation/wdh';
import Logger from '../../../../wdh-foundation/wdh-logger/wdh-logger';
/* global ShopUI */

/**
 * Initialization component responsible for setting up client library, translation manager, configuration manager and sitelink manager
 * Additionally the component adds the level 3 menu items to the menu
 *
 * This component is required on all pages with other b2b shop components
 * @memberOf module:wdh-feature-b2b
 */
var WDHFeatureB2BShopInitializationSpot = /*#__PURE__*/function (_WDHComponent) {
  function WDHFeatureB2BShopInitializationSpot() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'wdh-feature-b2b-shopinitializationspot';
    _classCallCheck(this, WDHFeatureB2BShopInitializationSpot);
    return _callSuper(this, WDHFeatureB2BShopInitializationSpot, [className]);
  }
  _inherits(WDHFeatureB2BShopInitializationSpot, _WDHComponent);
  return _createClass(WDHFeatureB2BShopInitializationSpot, [{
    key: "init",
    value: function init(component) {
      // Load Configuration
      if (typeof ShopUI !== 'undefined') {
        ShopUI.ConfigurationManager.loadConfiguration(document.getElementById('B2BConfiguration'));
        ShopUI.TranslationManager.loadTranslations(document.getElementById('B2BShopAllTranslations'));
        ShopUI.SiteLinkManager.loadSiteLinks(document.getElementById('B2BShopSiteLinks'));
        var sessionDetails = JSON.parse(document.getElementById('B2BSessionDetails').innerHTML);
        ShopUI.ConfigurationManager.setUserId(sessionDetails.user);
        if (!ShopUI.ConfigurationManager.isConfigured()) {
          return;
        }
        var config = {
          endpoint: ShopUI.ConfigurationManager.getShopServiceEndPoint(),
          token: sessionDetails.token,
          tokenKeepAliveUrl: '/api/shop/keepAlive',
          tokenKeepAliveDelay: 60000,
          language: sessionDetails.currentlanguage,
          mock: false,
          telemetry: ShopUI.ConfigurationManager.getTelemetry()
        };
        if (ShopUI.HttpClientInstance) {
          ShopUI.HttpClientInstance.configure(config);
        }
      }
      if (ShopUI.ShopInitialization === undefined) {
        Logger.warn('ShopInitialization not initialized. Missing UI component.');
        return;
      }
      ReactDOM.render(/*#__PURE__*/React.createElement(ShopUI.ShopInitialization, {
        className: this.className
      }, null), component.querySelector('.component-content'));
    }
  }]);
}(WDHComponent);
export default WDHFeatureB2BShopInitializationSpot;